module.exports = __webpack_public_path__ + "img/12.1e9ef617.png";